export const isIconObject = (icon: unknown) =>
  typeof icon === 'object' && icon !== null && 'src' in icon;
